module.exports = __webpack_public_path__ + "static/sc-04-8effd7ebd226cd3a4af1dc3d54667e4a.png";